import { DiContainer } from "@/modules/di/di-container";
import { BusinessOffersService } from "@/modules/offer/services/business-offers.service";
import { Modal } from "antd";

const businessOffersService = DiContainer.get(BusinessOffersService);

export const cancelTradeOffer = (id: number, successFoo: () => Promise<void>, isStationary?: boolean, mix_signature?: string) => {
    Modal.confirm({
      title: 'Подтвердите действие',
      content: `Вы действительно хотите отменить сделку с участием данного ${isStationary ? 'объема' : 'рукава'}?`,
      okText: 'да',
      cancelText: 'нет',
      onOk: async () => {
        await businessOffersService.deleteBusinessOffer(id, mix_signature);
        await successFoo();
      },
      okButtonProps: { danger: true },
    });
  };